import React from 'react';
import { Link } from 'react-router-dom';
import { FOOTER } from '@/constants/testIds';
import { StatusIndicator } from '@/components/StatusIndicator';
import { Mail } from 'lucide-react';

const CONTACT_EMAIL = 'info@revcoreai.com';

export const Footer = () => {
  return (
    <footer data-testid={FOOTER.container} className="border-t border-border/60 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-2 md:grid-cols-5 gap-8">
        <div className="col-span-2">
          <div className="display text-base font-semibold">RevCore<span className="brand-green">.AI</span></div>
          <p className="text-xs text-white/50 mt-2 max-w-[280px]">The agentic revenue OS for operators who ship. Hire AI agents, build your own, ship before lunch.</p>
          <div className="mt-4 flex items-center gap-2 flex-wrap">
            <StatusIndicator />
            <a href="https://status.revcoreai.com" target="_blank" rel="noopener noreferrer" className="text-[11px] text-white/50 hover:text-white underline underline-offset-2">
              status.revcoreai.com
            </a>
          </div>
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            data-testid="footer-contact-email"
            className="mt-4 inline-flex items-center gap-2 text-[12px] text-white/70 hover:text-[#39FF14] transition-colors group"
          >
            <Mail className="h-3.5 w-3.5 text-[#39FF14]" />
            <span className="mono">{CONTACT_EMAIL}</span>
          </a>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-white/40 mb-3">Product</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/marketplace" className="hover:text-white">Marketplace</Link></li>
            <li><Link to="/use-cases" className="hover:text-white">Use cases</Link></li>
            <li><Link to="/builder" className="hover:text-white">Builder</Link></li>
            <li><Link to="/docs" className="hover:text-white">Docs / API</Link></li>
            <li><Link to="/pricing" className="hover:text-white">Pricing</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-white/40 mb-3">Company</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li><a className="hover:text-white" href="#">About</a></li>
            <li><a className="hover:text-white" href="#">Careers</a></li>
            <li><a className="hover:text-white" href="#">Blog</a></li>
            <li><a className="hover:text-white" href={`mailto:${CONTACT_EMAIL}`}>Contact</a></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-white/40 mb-3">Trust</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li><a className="hover:text-white" href="#">Security</a></li>
            <li><a className="hover:text-white" href="#">SOC 2</a></li>
            <li><a className="hover:text-white" href="#">Privacy</a></li>
            <li><a className="hover:text-white" href="#">Terms</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border/60">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex items-center justify-between text-xs text-white/40 flex-wrap gap-2">
          <span>© {new Date().getFullYear()} RevCore AI. All rights reserved.</span>
          <span className="mono">v1.3.0 · agentic-revenue-os</span>
        </div>
      </div>
    </footer>
  );
};
